import {
  AlertModalController
} from './alert-modal/alert-modal.component';

export class ErrorHandlerService {
  constructor(
    globalAlert,
    $modal,
    PermissionService,
    LocalStorageService,
    LayoutService,
    $timeout,
  ) {
    this.globalAlert = globalAlert;
    this.$modal = $modal;
    this.$timeout = $timeout;
    this.modalOpened = false;
    this.LayoutService = LayoutService;
    this.LocalStorageService = LocalStorageService;
    this.PermissionService = PermissionService;
    this.notShowErrorMessageBox = false;
    this.wrongCuts = [];
  }

  $showErrorMessageBox(errorStatus, errorText, errorConfig, isYes = false) {
    if (this.modalOpened) return;
    this.modalOpened = true;
    const inst = this.$modal.open({
      template: require('./alert-modal/alert-modal.component.html'),
      controller: AlertModalController,
      resolve: {
        errorStatus: () => errorStatus,
        errorText: () => errorText,
        errorConfig: () => errorConfig,
        isYes: () => isYes,
      },
    });
    inst.result.then(res => this.modalOpened = false);
    return inst;
  }

  isWrongCuts(cuts) {
    return this.wrongCuts.some(w => cuts.every(c => !(c.dimension in w && w[c.dimension] === c.value)));
  }

  showErrorMessageBox(errorStatus, errorText, errorConfig, notReload) {

    const home = () => {
      if (notReload || window.location.hash === '#!/') return;
      if (this.LayoutService.options.saveInterface.value)
        this.LocalStorageService.setItem('locationUrl', '/');
      window.location = '/';
    };

    const errMsg = this.$showErrorMessageBox(errorStatus, errorText, errorConfig);
    if (!errMsg) return;
    errMsg.result
      .then(res => {
        this.modalOpened = false;

        const support = ' <a target="_blank" class="blue-link" href="https://help.staffcop.ru/?lang=' +
          this.PermissionService.selectedLang + '">' +
          gettext('службу поддержки') + '</a>.';

        if (errorConfig && errorConfig.resultData && !errorConfig.resultError) {
          const htmlText = gettext('Сообщение об ошибке зарегистрировано под номером') +
            ' <b>#' + errorConfig.resultData + '</b>\n' +
            gettext('Вы можете узнать его статус, обратившись в') + support;

          const inst = this.$showErrorMessageBox(gettext('Спасибо, что помогаете cтать нам лучше'), htmlText);
        } else if (errorConfig && !errorConfig.resultData && errorConfig.resultError) {
          const text = gettext('Обратитесь, пожалуйста, в') + support + '\n\n' + errorText;
          const inst = this.$showErrorMessageBox(gettext('Ошибка отправки'), text);
        }
      }, );
  }

  handle(error) {
    this.$timeout(() => {
      if (error && error.status) {
        if (!angular.isString(error.data)) { error.data = gettext('Неизвестная ошибка'); }
        return this.handleServerError(error);
      }
      console.error(error || gettext('Неизвестная ошибка'));
      const message = error && error.message || gettext('Неизвестная ошибка');
      if (message) {
        this.globalAlert(
          message,
          3000,
        );
      }
    }, 700);
  }


  handleServerError({
    status,
    data,
    config,
  }) {
    if (status === -1 || status === 502) {
      this.showErrorMessageBox(
        gettext('Ошибка сервера '),
        gettext('Cервер недоступен или отсутствует интернет-соединение'),
      );
      return;
    } else if (status === 403) {
      window.open('/accounts/login/?is_session_expired=True', '_self');
      // this.showErrorMessageBox(
      //   gettext('Ошибка сервера ') + status,
      //   gettext('Нет доступа или сессия пользователя была завершена')
      // );
      return;
    }
    if (status === 422) {
      this.globalAlert(data, 3000);
      return;
    }
    if (status === 500) {
      if (this.filterErrorMessage) this.filterErrorMessage.text = gettext('Ошибка') + ': ' + data.match(/^(.*)$/m)[0];
      if (config && config.params && config.params.dim && config.params.filter) {
        this.wrongCuts.push(config.params.dim.reduce((res, d, i) => {
          res[d] = config.params.filter[i];
          return res;
        }, {}));
      }
      if (!this.notShowErrorMessageBox)
        this.showErrorMessageBox(status, data, config, this.filterErrorMessage && this.filterErrorMessage.notReload);
      return;
    }

    console.error(data);
    this.globalAlert(
      gettext('Ошибка сервера ') + status +
      gettext(
        '. Попробуйте повторить последнюю операцию или перезагрузите страницу'),
      3000,
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/error-handler.service.js